/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState, useEffect } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import getCroppedImg from "../../utils/cropImage";
import useSaveTemplate from "../../utils/customHooks";
import ImageUploader from "../../utils/ImageUploader";
import { CropperWrapper } from "../../utils/CropperWrapper";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

export const Basnie47: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("KSIĘGA BAŚNI");
  const [text2, setText2] = useState<string>("Kajetana");
  const [text3, setText3] = useState<string>("Wszystko, co piękne i wymarzone,");
  const [text4, setText4] = useState<string>("niech w Twym życiu będzie spełnione.");
  const [text5, setText5] = useState<string>("Ciocia Natalia");
  const [text6, setText6] = useState<string>("3100 g radości");

  const text1BasicSize = 36;
  const text2BasicSize = 100;
  const text3BasicSize = 34;
  const text4BasicSize = 34;
  const text5BasicSize = 34;
  const text6BasicSize = 30;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
    const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
    const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 800; // Maximum width for text
  const maxWidth2 = 550;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'adlery-pro'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'adlery-pro'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'adlery-pro'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

    const adjustFontSize2 = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'adlery-pro'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth2 && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'adlery-pro'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth2 * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'adlery-pro'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize2(text3, fontSizeText3, text3BasicSize, 10));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize2(text4, fontSizeText4, text4BasicSize, 10));
  }, [text4]);

  useEffect(() => {
    setFontSizeText5(adjustFontSize2(text5, fontSizeText5, text5BasicSize, 10));
  }, [text5]);
  useEffect(() => {
    setFontSizeText6(adjustFontSize2(text6, fontSizeText6, text6BasicSize, 10));
  }, [text6]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };
  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (<div style={{
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff", padding: "60px",
    position: "relative",
  }}>
    {/* Spinner Overlay */}
    <SpinnerOverlay isVisible={isSaving} />
    <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
      <ImageUploader
        onImageChange={(image) => setImage(image)}
        setStep={setStep}
      />
      {step === "crop" && (
        <p>
          Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
        </p>
      )}
      {step !== "crop" && (
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      )}
      {step === "crop" && (
        <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
      )}
    </div>

    <div
      id="printable-content"
      style={{
        position: "relative",
        width: pdfWidth,
        height: pdfHeight,
        fontFamily: "AbrilFatface-Regular, adlery-pro, Cardo-Regular",
        backgroundColor: "#ffffff",
        margin: "auto",
        marginTop: "20px"
      }}
    >          <InlineEdit
        value={text1}
        setValue={setText1}
        style={{
          fontSize: `${fontSizeText1}px`,
          lineHeight: `${fontSizeText1}px`,
          width: `${maxWidth}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          top: '77px', // Zmienione położenie
          margin: 'auto',
          left: '0px',
          right: '0px',
          fontFamily: 'AbrilFatface-Regular',
          color: "#56698f",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "400",
        }}
      />
      <InlineEdit
        value={text2}
        setValue={setText2}
        style={{
          fontSize: `${fontSizeText2}px`,
          lineHeight: `${fontSizeText2}px`,
          width: `${maxWidth}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          top: '130px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '0',
          fontFamily: 'adlery-pro',
          color: "#56698f",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "400",
        }}
      />
      <InlineEdit
        value={text3}
        setValue={setText3}
        style={{
          fontSize: `${fontSizeText3}px`,
          lineHeight: `${fontSizeText3}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '152px', // Zmienione położenie
          margin: 'auto',
          // left: '100px',
          right: '80px',
          width: "600px",
          fontFamily: 'Cardo-Regular',
          color: "#56698f",
          zIndex: "12",
          textAlign: "right",
          fontWeight: "400",
          // letterSpacing: "0.0001em"
        }}
      />

      <InlineEdit
        value={text4}
        setValue={setText4}
        style={{
          fontSize: `${fontSizeText4}px`,
          lineHeight: `${fontSizeText4}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '107px', // Zmienione położenie
          margin: 'auto',
          // left: '100px',
          right: '80px',
          width: "600px",
          fontFamily: 'Cardo-Regular',
          color: "#56698f",
          zIndex: "12",
          textAlign: "right",
          fontWeight: "400",
          // letterSpacing: "0.0001em"
        }}
      />
      <InlineEdit
        value={text5}
        setValue={setText5}
        style={{
          fontSize: `${fontSizeText5}px`,
          lineHeight: `${fontSizeText5}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '59px', // Zmienione położenie
          margin: 'auto',
          // left: '100px',
          right: '80px',
          width: "400px",
          fontFamily: 'Cardo-Regular',
          color: "#56698f",
          zIndex: "12",
          textAlign: "right",
          fontWeight: "400",
          // letterSpacing: "0.0001em"
        }}
      />
       {/* <InlineEdit
        value={text6}
        setValue={setText6}
        style={{
          fontSize: `${fontSizeText6}px`,
          lineHeight: `${fontSizeText6}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '35px', // Zmienione położenie
          margin: 'auto',
          left: '100px',
          // right: '10px',
          width: "400px",
          fontFamily: 'AbrilFatface-Regular',
          color: "#672622",
          zIndex: "12",
          textAlign: "left",
          fontWeight: "400",
          // letterSpacing: "0.0001em"
        }}
      /> */}
      {/* Step: Crop */}
      {image && step === "crop" && (
        <CropperWrapper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={400 / 400}
          cropShape="round"
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          style={{
            top: "364px",
            left: "495px",
            width: "400px",
            height: "400px",
            transform: "translateX(-50%)",
            zIndex: 4,
            borderRadius: "50%"
          }}
        />
      )}

      {/* Step: View */}
      {croppedImage && step === "view" && (
        <img
          src={croppedImage}
          style={{
            position: "absolute",
            top: "364px",
            left: "495px",
            width: "400px",
            height: "400px",
            transform: "translateX(-50%)",
            zIndex: 2,
            borderRadius: "50%"
          }}
        />
      )}

      {/* <img
          src="/images/Basnie47overlay.svg"
          style={{
            position: "absolute",
            zIndex: 5,
            width: "100%",
            height: "100%",
          }}
        /> */}
      <img
        src="/images/Basnie47.svg"
        style={{ width: "100%", height: "100%", position: "relative", zIndex: 3 }}
      />
    </div>
  </div>
  );
};